// extracted by mini-css-extract-plugin
module.exports = {"container":"InlineAlert_container__aSjQb","neutral":"InlineAlert_neutral__QN1PB"};